import React from 'react';
import { Badge } from "react-bootstrap";

const TenancyInfoEnvironment = ({ live }) => {
  let variant = 'warning';
  let text = 'test';

  switch (live) {
    case 2:
      variant = 'success';
      text = 'live';
      break;

    default:
      break;
  }

  return <Badge variant={ variant }>{ text }</Badge>
}

export default TenancyInfoEnvironment;